import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ManhwaCard from '@/components/base/ManhwaCard';
import SchemaOrg from '@/components/base/SchemaOrg';
import { usePageMeta } from '@/hooks/usePageMeta';
import { featuredManhwa, categories, stats } from '@/mocks/manhwa';

const allManhwa = [
  ...featuredManhwa,
  {
    id: 7, title: '暴君的小娇妻', author: '郑秀雅', category: '浪漫爱情', slug: 'tyrant-wife',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20royal%20couple%20in%20historical%20palace%20setting%2C%20soft%20pink%20and%20gold%20tones%2C%20romantic%20webtoon%20cover%20art%20style%2C%20elegant%20atmosphere%2C%20clean%20composition&width=800&height=1120&seq=manhwa-cover-07&orientation=portrait',
    rating: 8.8, chapters: 134, views: 2670000, updateDate: '2026-07-01', tags: ['宫廷', '爱情', '甜宠']
  },
  {
    id: 8, title: '魔法学院优等生', author: '金泰亨', category: '奇幻冒险', slug: 'magic-academy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20students%20in%20a%20magical%20academy%20with%20floating%20spells%2C%20warm%20golden%20and%20emerald%20tones%2C%20webtoon%20cover%20art%20style%2C%20magical%20atmosphere&width=800&height=1120&seq=manhwa-cover-08&orientation=portrait',
    rating: 9.3, chapters: 89, views: 3450000, updateDate: '2026-07-02', tags: ['魔法', '校园', '成长']
  },
  {
    id: 9, title: '职场女王', author: '申慧珍', category: '都市职场', slug: 'office-queen',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20business%20illustration%20of%20a%20confident%20woman%20in%20modern%20office%20setting%2C%20sleek%20professional%20style%2C%20warm%20neutral%20tones%2C%20webtoon%20cover%20art&width=800&height=1120&seq=manhwa-cover-09&orientation=portrait',
    rating: 8.6, chapters: 178, views: 4230000, updateDate: '2026-07-03', tags: ['职场', '励志', '女性']
  },
  {
    id: 10, title: '九尾狐传说', author: '朴美英', category: '奇幻冒险', slug: 'nine-tailed-fox',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20mysterious%20nine%20tailed%20fox%20spirit%20in%20traditional%20Korean%20setting%2C%20ethereal%20mist%2C%20warm%20amber%20and%20crimson%20tones%2C%20webtoon%20cover%20art&width=800&height=1120&seq=manhwa-cover-10&orientation=portrait',
    rating: 9.4, chapters: 56, views: 1890000, updateDate: '2026-06-30', tags: ['神话', '奇幻', '古风']
  },
  {
    id: 11, title: '末日求生指南', author: '郑宇', category: '悬疑惊悚', slug: 'apocalypse-survival',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20survival%20thriller%20illustration%20of%20survivors%20in%20a%20post%20apocalyptic%20city%2C%20dramatic%20lighting%2C%20dark%20warm%20earth%20tones%2C%20webtoon%20cover%20art%20style%2C%20tense%20atmosphere&width=800&height=1120&seq=manhwa-cover-11&orientation=portrait',
    rating: 9.0, chapters: 112, views: 2780000, updateDate: '2026-07-02', tags: ['末日', '生存', '惊险']
  },
  {
    id: 12, title: '三生三世桃花开', author: '林秀晶', category: '仙侠修真', slug: 'peach-blossom',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20romance%20illustration%20of%20a%20fairy%20couple%20under%20blooming%20peach%20trees%2C%20soft%20pink%20and%20jade%20green%20tones%2C%20dreamy%20webtoon%20cover%20art%20style&width=800&height=1120&seq=manhwa-cover-12&orientation=portrait',
    rating: 9.1, chapters: 201, views: 5670000, updateDate: '2026-07-03', tags: ['仙侠', '爱情', '轮回']
  },
];

const categoryHeroMap: Record<string, { title: string; desc: string; heroImage: string; statsImage: string }> = {
  romance: {
    title: '浪漫爱情',
    desc: '收录1,280部浪漫爱情韩漫，甜宠、虐恋、纯爱一网打尽',
    heroImage: 'https://readdy.ai/api/search-image?query=Warm%20pink%20and%20rose%20abstract%20flowing%20gradient%20art%20illustration%20with%20soft%20romantic%20shapes%2C%20dreamy%20atmosphere%2C%20delicate%20curves%2C%20digital%20minimalist%20composition%2C%20clean%20elegant%20design&width=1920&height=920&seq=category-hero-romance&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Soft%20pastel%20pink%20to%20warm%20cream%20abstract%20shapes%20with%20overlapping%20organic%20circles%20and%20ovals%2C%20gentle%20layering%20effect%2C%20romantic%20dreamy%20digital%20art%20composition&width=640&height=400&seq=cat-stats-romance&orientation=landscape',
  },
  fantasy: {
    title: '奇幻冒险',
    desc: '收录960部奇幻冒险韩漫，魔法、龙与剑的史诗旅程',
    heroImage: 'https://readdy.ai/api/search-image?query=Golden%20amber%20and%20warm%20bronze%20abstract%20flowing%20gradient%20illustration%20with%20epic%20adventure%20shapes%2C%20magical%20atmosphere%2C%20sweeping%20curves%2C%20digital%20minimalist%20composition%2C%20heroic%20feel&width=1920&height=920&seq=category-hero-fantasy&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Warm%20golden%20amber%20to%20cream%20abstract%20shapes%20with%20overlapping%20geometric%20circles%2C%20heroic%20epic%20digital%20art%20composition%2C%20soft%20layering&width=640&height=400&seq=cat-stats-fantasy&orientation=landscape',
  },
  thriller: {
    title: '悬疑惊悚',
    desc: '收录540部悬疑惊悚韩漫，烧脑推理、心跳加速',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20warm%20charcoal%20and%20deep%20crimson%20abstract%20gradient%20illustration%20with%20mysterious%20shadow%20shapes%2C%20tense%20atmosphere%2C%20angular%20lines%2C%20digital%20minimalist%20composition%2C%20noir%20feel&width=1920&height=920&seq=category-hero-thriller&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Dark%20warm%20tones%20to%20deep%20red%20abstract%20shapes%20with%20overlapping%20angular%20forms%2C%20mysterious%20digital%20art%20composition%2C%20noir%20atmosphere&width=640&height=400&seq=cat-stats-thriller&orientation=landscape',
  },
  urban: {
    title: '都市职场',
    desc: '收录720部都市职场韩漫，商战风云、职场百态',
    heroImage: 'https://readdy.ai/api/search-image?query=Warm%20neutral%20beige%20and%20taupe%20abstract%20gradient%20illustration%20with%20modern%20city%20silhouette%20shapes%2C%20professional%20atmosphere%2C%20clean%20lines%2C%20digital%20minimalist%20composition&width=1920&height=920&seq=category-hero-urban&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Neutral%20beige%20to%20warm%20cream%20abstract%20shapes%20with%20modern%20geometric%20circles%2C%20professional%20clean%20digital%20art%20composition&width=640&height=400&seq=cat-stats-urban&orientation=landscape',
  },
  cultivation: {
    title: '仙侠修真',
    desc: '收录450部仙侠修真韩漫，御剑飞行、修仙问道',
    heroImage: 'https://readdy.ai/api/search-image?query=Jade%20green%20and%20misty%20gold%20abstract%20flowing%20gradient%20illustration%20with%20ethereal%20mountain%20shapes%2C%20spiritual%20atmosphere%2C%20flowing%20curves%2C%20digital%20minimalist%20composition&width=1920&height=920&seq=category-hero-cultivation&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Jade%20green%20to%20misty%20gold%20abstract%20shapes%20with%20floating%20ethereal%20circles%2C%20spiritual%20dreamy%20digital%20art%20composition&width=640&height=400&seq=cat-stats-cultivation&orientation=landscape',
  },
  healing: {
    title: '治愈日常',
    desc: '收录380部治愈日常韩漫，温暖人心的小确幸',
    heroImage: 'https://readdy.ai/api/search-image?query=Soft%20cream%20and%20warm%20pastel%20abstract%20flowing%20gradient%20illustration%20with%20gentle%20organic%20shapes%2C%20cozy%20atmosphere%2C%20round%20curves%2C%20digital%20minimalist%20composition&width=1920&height=920&seq=category-hero-healing&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Soft%20cream%20to%20warm%20pastel%20abstract%20shapes%20with%20cozy%20organic%20circles%2C%20gentle%20healing%20digital%20art%20composition&width=640&height=400&seq=cat-stats-healing&orientation=landscape',
  },
  'martial-arts': {
    title: '武侠江湖',
    desc: '收录620部武侠江湖韩漫，快意恩仇、侠骨柔情',
    heroImage: 'https://readdy.ai/api/search-image?query=Warm%20earth%20brown%20and%20deep%20red%20abstract%20flowing%20gradient%20illustration%20with%20martial%20brushstroke%20shapes%2C%20heroic%20atmosphere%2C%20bold%20lines%2C%20digital%20minimalist%20composition&width=1920&height=920&seq=category-hero-martial&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Earth%20brown%20to%20deep%20red%20abstract%20shapes%20with%20bold%20brushstroke%20circles%2C%20heroic%20digital%20art%20composition&width=640&height=400&seq=cat-stats-martial&orientation=landscape',
  },
  'sci-fi': {
    title: '科幻未来',
    desc: '收录310部科幻未来韩漫，星际穿越、未来世界',
    heroImage: 'https://readdy.ai/api/search-image?query=Silver%20and%20warm%20teal%20abstract%20gradient%20illustration%20with%20futuristic%20geometric%20shapes%2C%20space%20atmosphere%2C%20clean%20angular%20lines%2C%20digital%20minimalist%20composition&width=1920&height=920&seq=category-hero-scifi&orientation=landscape',
    statsImage: 'https://readdy.ai/api/search-image?query=Silver%20to%20warm%20teal%20abstract%20shapes%20with%20futuristic%20geometric%20circles%2C%20space%20modern%20digital%20art%20composition&width=640&height=400&seq=cat-stats-scifi&orientation=landscape',
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const catInfo = categoryHeroMap[slug || ''] || categoryHeroMap.romance;
  const catMeta = categories.find((c) => c.slug === slug) || categories[0];

  usePageMeta({
    title: `${catInfo.title}韩漫免费阅读_虚空韩漫网`,
    description: `虚空韩漫网${catInfo.title}分类，${catInfo.desc}。收录${catMeta.count.toLocaleString()}部韩漫作品，支持下拉式免费在线阅读。`,
    keywords: `${catInfo.title}韩漫,${catInfo.title}漫画,韩漫免费阅读,虚空韩漫网,韩国漫画${catInfo.title}`,
    canonicalUrl: `http://jiukuguoji.com/category/${slug || 'romance'}`,
    ogType: 'website',
  });

  const filteredManhwa = allManhwa.filter((m) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? m.category === cat.name : true;
  });

  return (
    <>
      <Navbar />

      <main>
        <section className="relative h-[350px] md:h-[460px] w-full overflow-hidden">
          <img
            src={catInfo.heroImage}
            alt={`${catInfo.title} - 虚空韩漫网`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>
          <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 text-center">
            <h1 className="text-2xl md:text-5xl font-heading font-black text-white tracking-wide mb-3">
              {catInfo.title}
            </h1>
            <p className="text-sm md:text-lg text-white/80 max-w-2xl leading-relaxed mb-6">
              {catInfo.desc}
            </p>
            <Link
              to={`/article/${filteredManhwa[0]?.slug || 'sword-and-magic'}`}
              className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-white font-medium text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              进入阅读
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>
        </section>

        <Breadcrumb items={[{ name: '首页', path: '/' }, { name: catInfo.title }]} />

        <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
          <div className="mb-8 md:mb-10">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900">
              {catInfo.title}
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              共 {catMeta.count.toLocaleString()} 部作品
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop="">
            {(filteredManhwa.length > 0 ? filteredManhwa : allManhwa).map((item) => (
              <ManhwaCard key={item.id} {...item} />
            ))}
          </div>
        </section>

        <section className="w-full bg-background-100 py-10 md:py-14">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/2">
                <h3 className="text-lg md:text-2xl font-bold text-foreground-900 leading-snug mb-6">
                  {catInfo.title}分类<br />数据概览
                </h3>
                <div className="grid grid-cols-3 divide-x divide-background-300">
                  <div className="pr-3 md:pr-5">
                    <div className="text-xl md:text-3xl font-heading font-bold text-accent-500">{catMeta.count.toLocaleString()}+</div>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">收录总量</p>
                  </div>
                  <div className="px-3 md:px-5">
                    <div className="text-xl md:text-3xl font-heading font-bold text-accent-500">320+</div>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">本周更新</p>
                  </div>
                  <div className="pl-3 md:pl-5">
                    <div className="text-xl md:text-3xl font-heading font-bold text-accent-500">280+</div>
                    <p className="text-xs md:text-sm text-foreground-500 mt-1">独家版权</p>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2">
                <div className="relative min-h-[200px] rounded-xl overflow-hidden">
                  <img
                    src={catInfo.statsImage}
                    alt=""
                    className="w-full h-full object-cover rounded-xl"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <SchemaOrg type="WebPage" data={{
        url: `http://jiukuguoji.com/category/${slug || 'romance'}`,
        name: `${catInfo.title}韩漫 - 虚空韩漫网`,
        description: `虚空韩漫网${catInfo.title}分类，${catInfo.desc}`,
        isPartOf: { '@type': 'WebSite', name: '虚空韩漫网', url: 'http://jiukuguoji.com/' },
      }} />
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://jiukuguoji.com/' },
          { '@type': 'ListItem', position: 2, name: catInfo.title },
        ],
      }} />
    </>
  );
}